<template>
  <div class="iframe-container pa-4">
    <div class="w-100" v-if="loading">
      <v-skeleton-loader type="article, card"></v-skeleton-loader>
    </div>
    <div v-else>
      <SummaryHeader class="pa-4" />
      <SummaryCard class="mb-4" :card="card" />
    </div>
  </div>
</template>

<script>
import { usePipedriveStore } from '../composables/use-pipedrive-store'

import AppExtensionsSDK, { Command, Modal } from '@pipedrive/app-extensions-sdk';

import { onMounted, ref, getCurrentInstance } from 'vue'

import SummaryHeader from '../components/SummaryHeader.vue';
import SummaryCard from '../components/SummaryCard.vue';

export default {
  components: {
    SummaryHeader,
    SummaryCard
  },
  setup() {
    const error = ref(null);
    const loading = ref(false);
    const card = ref({})

    const app = getCurrentInstance();
    console.log(app);
    const { loadRealEstateOrderSummary } = usePipedriveStore(app.root);

    const initializeSdk = async () => {
      try {
        // SDK detects identifier from URL and uses default custom UI size
        const app = new AppExtensionsSDK({ size: { height: 700, width: 1000 }, width: 1000 });

        if (!app) {
          throw new Error('ExtensionSDK não está disponível ou não contém o método initialize')
        }

        await app.initialize({
          clientId: process.env.VUE_APP_PIPEDRIVE_CLIENT_ID, // Certifique-se de configurar no .env
          identifier: "ddbdbf8e-c8d3-42ec-a1c7-4fc9f2ee56e3",
          size: { width: 806, height: 741 }
        })
      } catch (err) {
        console.error('Erro ao inicializar SDK:', err)
        error.value = 'Erro ao inicializar integração com Pipedrive'
      }
    }

    const loadSummary = async () => {
      try {
        const data = await loadRealEstateOrderSummary(1);
        card.value = data;
        console.log("data", data)
      } catch (error) {
        console.log(error);
      }
    }

    onMounted(async () => {
      try {
        loading.value = true
        await initializeSdk()
        await loadSummary()
      } catch (err) {
        error.value = err.message
      } finally {
        loading.value = false
      }
    });

    const openModal = async () => {
      await sdk.execute(Command.OPEN_MODAL, {
        type: Modal.DEAL,
        prefill: {
          title: 'Important deal',
        },
      });
    }

    return {
      openModal,
      card,
      loading,
    }
  }
}
</script>

<style scoped>
.iframe-container {
  padding: 0;
  margin: 0;
}
</style>